const SvgComponent = (props) => (
  <svg
    width={23}
    height={9}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m2.692.178 8.762 5.343L20.218.178l2.692 1.645-11.454 7L0 1.823 2.692.178Z"
      fill="#424242"
    />
  </svg>
);

export default SvgComponent;
